/* Running Premium - fiche produit : coloris, tailles, unites, prix, CTA */
(function () {
  'use strict';

  var form = document.getElementById('PdpForm');
  if (!form) return;

  var dataEl = document.querySelector('[data-pdp-variants]');
  var VARIANTS = [];
  try { VARIANTS = JSON.parse(dataEl.textContent); } catch (e) { VARIANTS = []; }

  var hidden = form.querySelector('[data-pdp-id]');
  var priceBox = document.querySelector('[data-pdp-price]');
  var sticky = document.querySelector('.pdp__sticky .btn');
  var addBtn = form.querySelector('[data-pdp-add]');
  var stage = document.querySelector('.pdp__stage img');
  var colorName = document.querySelector('[data-pdp-color-name]');
  var headMsg = document.querySelector('.pdp__sizes-head span');
  var UNIT_KEY = 'rp_size_unit';

  var hasColor = VARIANTS.some(function (v) { return v.color; });

  function selectedColor() {
    var i = form.querySelector('input[name="pdp-color"]:checked');
    return i ? i.value : '';
  }
  function selectedSize() {
    var i = form.querySelector('input[name="pdp-size"]:checked');
    return i ? i.value : '';
  }
  function findVariant(color, size) {
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if (hasColor && v.color !== color) continue;
      if (v.size !== size) continue;
      return v;
    }
    return null;
  }
  function firstAvailable(color) {
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if (hasColor && v.color !== color) continue;
      if (v.available) return v;
    }
    return null;
  }

  /* --- Tailles : une seule fois chaque pointure, dispo selon le coloris --- */
  function refreshSizes() {
    var color = selectedColor();
    var current = selectedSize();
    var stillOk = false;

    form.querySelectorAll('.pdp__size').forEach(function (label) {
      var size = label.getAttribute('data-size');
      var variant = findVariant(color, size);
      var input = label.querySelector('input');
      var ok = !!(variant && variant.available);
      if (input) {
        input.disabled = !ok;
        if (variant) input.setAttribute('data-variant-id', variant.id);
        if (input.checked && ok) stillOk = true;
        if (input.checked && !ok) input.checked = false;
      }
      label.classList.toggle('is-out', !ok);
      label.hidden = !variant;
    });

    if (!stillOk && current) {
      var head = document.querySelector('.pdp__sizes-head span');
      if (head) head.textContent = 'Select size';
    }
  }

  function updatePrice(variant) {
    if (!variant) return;
    if (hidden) hidden.value = variant.id;
    if (priceBox && variant.price) {
      priceBox.innerHTML = '<span>' + variant.price + '</span>' + (variant.compare ? '<s>' + variant.compare + '</s>' : '');
    }
    if (sticky && variant.price && !sticky.disabled) {
      sticky.textContent = 'Add to bag - ' + variant.price;
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function syncVariant() {
    var size = selectedSize();
    if (!size) return;
    var variant = findVariant(selectedColor(), size);
    if (variant) updatePrice(variant);
  }

  /* --- Coloris --- */
  function onColorChange() {
    var color = selectedColor();

    form.querySelectorAll('.pdp__colorpick').forEach(function (label) {
      var input = label.querySelector('input');
      label.classList.toggle('is-on', !!(input && input.checked));
    });

    if (colorName) colorName.textContent = color;

    var shot = firstAvailable(color) || findVariant(color, selectedSize());
    if (stage && shot && shot.image) {
      stage.setAttribute('src', shot.image);
      stage.removeAttribute('srcset');
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    }

    refreshSizes();
    syncVariant();
    if (!selectedSize() && shot) updatePrice(shot);
  }

  form.addEventListener('change', function (event) {
    if (event.target.name === 'pdp-color') { onColorChange(); return; }
    if (event.target.name === 'pdp-size') {
      if (headMsg) { headMsg.textContent = 'Select size'; headMsg.style.color = ''; }
      syncVariant();
    }
  });

  form.addEventListener('submit', function (event) {
    if (!form.querySelector('.pdp__size')) return;
    var checked = form.querySelector('input[name="pdp-size"]:checked');
    if (!checked) {
      event.preventDefault();
      if (headMsg) { headMsg.textContent = 'Please choose a size'; headMsg.style.color = '#b3261e'; }
      var grid = document.querySelector('.pdp__size-grid');
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (addBtn) addBtn.textContent = 'Adding...';
  });

  /* --- Unites de pointure --- */
  function readUnit() {
    try { return window.sessionStorage.getItem(UNIT_KEY) || 'usm'; } catch (e) { return 'usm'; }
  }
  function writeUnit(u) {
    try { window.sessionStorage.setItem(UNIT_KEY, u); } catch (e) {}
  }
  function applyUnit(unit) {
    document.querySelectorAll('.pdp__size').forEach(function (label) {
      var value = label.getAttribute('data-' + unit);
      if (!value) return;
      var span = label.querySelector('[data-pdp-size-label]');
      if (span && span.textContent.trim() !== value) span.textContent = value;
      var input = label.querySelector('input');
      if (input) {
        var suffix = unit === 'eu' ? 'EU' : unit === 'uk' ? 'UK' : unit === 'usw' ? 'US womens' : 'US mens';
        input.setAttribute('aria-label', 'Size ' + value + ' ' + suffix);
      }
    });
    document.querySelectorAll('[data-pdp-unit]').forEach(function (btn) {
      btn.classList.toggle('is-on', btn.getAttribute('data-pdp-unit') === unit);
    });
  }
  document.querySelectorAll('[data-pdp-unit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var unit = btn.getAttribute('data-pdp-unit');
      writeUnit(unit);
      applyUnit(unit);
    });
  });

  applyUnit(readUnit());
  refreshSizes();
  if (hasColor) onColorChange();
  syncVariant();
})();
